// DS: DS4.2, DS4.2.1
import React from 'react';
import c from 'classnames';
import BiInput from '@wix/da-bi/pkg/Components/BiInput';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import CheckIcon from '../Icons/Check';
import s from './Checkbox.scss';

export interface Props {
  id?: string;
  name?: string;
  size?: 'small' /* DS4.2.1 */ | 'big' /* DS4.2 */;
  originalGreen?: boolean; // true - DS4.2.1, false - DS4.2.2
  children?: React.ReactNode; // @@deprecated use DS6.1 Selection List Item if you doing a list, otherwise use DS4.4 BooleanInput
  isChecked?: boolean;
  hasError?: boolean;
  className?: string;
  inputClassName?: string;
  labelClassName?: string; // @@deprecated
  disabled?: boolean;
  halfChecked?: boolean; // use - checkmark not tick
  ariaLabel?: string;
  ariaLabelledBy?: string;
  biData?: BiEvent;
  tabIndex?: number;
  onChange?: (
    isChecked: boolean,
    event?: React.ChangeEvent<HTMLInputElement>
  ) => void;
  onClick?: React.MouseEventHandler<HTMLLabelElement>;
  innerRef?: (node: HTMLElement | null) => void;
}

export const Checkbox: React.FC<Props> = ({
  id,
  name,
  size = 'big',
  originalGreen,
  children,
  isChecked,
  hasError,
  halfChecked,
  className,
  inputClassName,
  labelClassName,
  innerRef,
  disabled,
  ariaLabel,
  ariaLabelledBy,
  onChange,
  onClick,
  biData,
  tabIndex,
}) => {
  const icon =
    isChecked && halfChecked ? (
      <div className={c(s['icon'], s['icon-dash'])} />
    ) : (
      <CheckIcon className={c(s['icon'], s['icon-check'])} customSizable />
    );

  return (
    <label
      className={c(
        s['root'],
        isChecked && s['checked'],
        disabled && s['disabled'],
        hasError && s['has-error'],
        s[`size-${size}`],
        !originalGreen && s['new-colors'],
        className
      )}
      onClick={onClick}
      tabIndex={tabIndex ?? 0}
    >
      <BiInput
        type="checkbox"
        id={id}
        name={name}
        checked={isChecked}
        disabled={disabled}
        onChange={e => {
          onChange && onChange(!isChecked, e);
        }}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        biData={biData}
        innerRef={innerRef}
      />
      <div className={c(s['checkbox'], inputClassName)}>{icon}</div>
      {children && (
        <span className={c(s['label'], labelClassName)}>{children}</span>
      )}
    </label>
  );
};
Checkbox.displayName = 'Checkbox';

export default Checkbox;
